import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface ButtonProps {
  clickFunction: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: ReactNode
  text: string
  isDisabled?: boolean
}

function PrimaryIconButton ({ clickFunction, icon, text, isDisabled = false }: ButtonProps): ReactElement {
  const { siteTheme: { iconButton } } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      disabled={isDisabled}
      onClick={clickFunction}
      type="button"
      className={cn(iconButton.classes)}
    >
      <span className={cn(iconButton.iconClasses, 'mr-2')}>{icon}</span>
      {text}
    </button>
  )
}

export default PrimaryIconButton
